export const POSSIBLE_TEMPLATES = [
  {
    name: 'CIMO',
    subtitle: 'Context, Intervention, Mechanisms, Outcomes',
    useCase: 'For research on business, management or policy evaluation',
    sampleUrl: '65f1ede3cad408403be0d676'
  },
  {
    name: 'ECLIPSE',
    subtitle: 'Expectation, Client group, Location, Impact, Professionals, Service',
    useCase: 'For qualitative research investigating the outcomes of a policy or service',
    sampleUrl: '65f1ed1bcad408403be0d66e'
  },
  {
    name: 'PICO',
    subtitle: 'Problem/Population, Intervention, Comparison, Outcome',
    useCase: 'For clinical and healthcare related topics or quantitative research',
    sampleUrl: '65f1ec1fcad408403be0d647'
  },
  {
    name: 'SPICE',
    subtitle: 'Setting, Perspective, Intervention, Comparison, Evaluation',
    useCase: 'For qualitative research evaluating the outcomes of a service, project, or intervention',
    sampleUrl: '65f1ecdccad408403be0d666'
  },
  {
    name: 'SPIDER',
    subtitle: 'Sample, Phenomenon of Interest, Design, Evaluation, Research type',
    useCase: 'For qualitative or mixed methods research focused on samples rather than populations',
    sampleUrl: '65f1ec7bcad408403be0d64f'
  }
]



// WEBPACK FOOTER //
// ./src/utils/template-samples.js